var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgAmazonLoader = function SvgAmazonLoader(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 291.319 320",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "amazon-smile",
    d: "M252.089,239.901c-120.033,57.126-194.528,9.331-242.214-19.7c-2.95-1.83-7.966,0.428-3.614,5.426          c15.886,19.263,67.95,65.692,135.909,65.692c68.005,0,108.462-37.107,113.523-43.58          C260.719,241.321,257.169,237.78,252.089,239.901z           M285.8,221.284c-3.223-4.197-19.6-4.98-29.906-3.714          c-10.324,1.229-25.818,7.538-24.471,11.325c0.692,1.42,2.103,0.783,9.195,0.146c7.11-0.71,27.029-3.223,31.18,2.203          c4.17,5.462-6.354,31.49-8.275,35.687c-1.857,4.197,0.71,5.28,4.197,2.485c3.441-2.795,9.668-10.032,13.847-20.274          C285.718,238.845,288.249,224.479,285.8,221.284z",
    fill: "#1270a1",
    fillOpacity: 0,
    stroke: "#1270a1",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeDasharray: 2000,
    strokeDashoffset: 2000
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    from: 2000,
    to: 0,
    dur: "2s",
    repeatCount: "indefinite",
    id: "strokeAnimation"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#484848"
    },
    d: "M221.71,149.219V53.557C221.71,37.125,205.815,0,148.689,0C91.572,0,61.184,35.696,61.184,67.85          l47.74,4.27c0,0,10.633-32.136,35.313-32.136s22.987,19.992,22.987,24.316v20.784C135.607,86.149,57.096,95.18,57.096,161.382          c0,71.191,89.863,74.177,119.332,28.167c1.138,1.866,2.431,3.696,4.051,5.408c10.843,11.398,25.308,24.981,25.308,24.981          l36.852-36.415C242.658,183.513,221.71,167.071,221.71,149.219z           M112.511,152.578c0-30.579,32.764-36.779,54.722-37.507v26.319          C167.224,193.527,112.511,185.634,112.511,152.578z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAmazonLoader);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "assets/amazon-loader.6e6ee4cd4cfa611a1bff08b62dd14621.svg";